import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'core/components/Icon.js';

function Checkbox({checked, className, children, disabled, name, onChange}) {
    return (
        <label
            className={`${className ? className : ''} ${
                disabled ? 'disabled' : ''
            }`.trim()}
            onKeyPress={onChange}
            tabIndex="0"
        >
            <input
                aria-checked={checked}
                aria-disabled={disabled}
                checked={checked}
                disabled={disabled}
                name={name}
                onChange={onChange}
                role="checkbox"
                type="checkbox"
            />
            <Icon name="checkbox" />
            {children}
        </label>
    );
}

Checkbox.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
        PropTypes.object,
    ]).isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
    checked: false,
    disabled: false,
};

export default Checkbox;
